import { render } from "./ProofOfAttendance.vue?vue&type=template&id=b745cf40&scoped=true"
import script from "./ProofOfAttendance.vue?vue&type=script&lang=js"
export * from "./ProofOfAttendance.vue?vue&type=script&lang=js"

import "./ProofOfAttendance.vue?vue&type=style&index=0&id=b745cf40&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.virtualcp.app/releases/20260928150148/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b745cf40"]])

export default __exports__